import { FEATURE_FLAGS } from '../../../featureFlags';
import AppsList from './AppsList.vue';
import AppEditor from './AppEditor.vue';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.APP_BUILDER,
  permissions: ['administrator'],
};

export const routes = [
  {
    path: 'app-builder',
    name: 'apps_list',
    component: AppsList,
    meta: commonMeta,
  },
  {
    path: 'app-builder/:appId(\\d+)',
    name: 'app_editor',
    component: AppEditor,
    meta: commonMeta,
    props: route => ({ appId: route.params.appId }),
  },
];

export default routes;
